import { Injectable } from '@angular/core';
import { LegendItem, ProductionEvent } from '@groundworks/ngx-groundworks-ui';

export type ProductionEventVariant = NonNullable<ProductionEvent['variant']>;

const SERVICE_LINE_TYPE_MAP: ReadonlyMap<string, ProductionEventVariant> = new Map([
  ['58311859-82eb-4ffb-8f30-020967b3e844', 'crawlspace-water-management'],
  ['a603584a-c9aa-434e-927c-1f1ba702ad7b', 'foundation-repair'],
  ['882401bb-37aa-4203-bdfa-6e78f87bdf86', 'basement-water-management'],
  ['31b5334a-8d89-4d1a-8a30-b264c44dc1e5', 'ancilliary-services'],
  ['bf60fb08-4413-45ed-8211-fedbcf3741c0', 'concrete-repair'],
]);

const LEGEND_ITEMS: LegendItem[] = [
  { label: 'Ancillary Services', type: 'ancillary-services' },
  { label: 'Basement Water Management', type: 'basement-water-management' },
  { label: 'Concrete Repair', type: 'concrete-repair' },
  { label: 'Crawlspace Water Management', type: 'crawlspace-water-management' },
  { label: 'Foundation Repair', type: 'foundation-repair' },
  { label: 'Customer Satisfaction Visit', type: 'punchwork' },
  { label: 'Unavailable', type: 'unavailable'},
];

@Injectable({ providedIn: 'root' })
export class ServiceLineService {
  getLegendItems(): LegendItem[] {
    return LEGEND_ITEMS;
  }

  getVariantById(serviceLineId: string): ProductionEventVariant {
    return SERVICE_LINE_TYPE_MAP.get(serviceLineId.toLowerCase()) ?? 'default';
  }
}
